import React, { useEffect, useState } from 'react';
import ComboSimple from '../../../../../shared/components/Combos/Simple';

interface TipoSociedad{
nombre:string;
tipo:string;
}

const _options: TipoSociedad[] = [{nombre:'Filial',tipo:'F'},{nombre:'Sucursal',tipo:'S'},{nombre:'Ute',tipo:'U'},{nombre:'Elecnor',tipo:'E'}]

export const ComboTipoSociedad = (props:any) =>{

  let {data} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    setOptions(getOptions())
  },[])

//   useEffect(()=>{
//     if(data)
//     {
//       setOptions(getOptions())
//     }
//   },[props])

  const getOptions = () =>{
    //let op = [{ value: null, inputDisplay: "" }]
    let result = _options.map((ts: TipoSociedad)=> { return { value: ts.tipo, inputDisplay: ts.nombre } })
    return [...result]
  }

  return (
    <ComboSimple {...props} options={options} name="selectTipoSociedad"/>
  )
}
export default ComboTipoSociedad